import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Clock } from 'lucide-react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 14,
    seconds: 59
  });
  const [isVisible, setIsVisible] = useState(true);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else {
          clearInterval(timer);
          return prev;
        }
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed top-0 left-0 w-full z-50 bg-zinc-900 border-b border-green-500/30 py-2 px-4 shadow-lg" data-id="element-209">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2 text-center sm:text-left" data-id="element-210">
        <div className="flex items-center gap-3" data-id="element-211">
          <span className="relative flex h-3 w-3" data-id="element-212">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" data-id="element-213"></span>
            <span className="relative inline-flex rounded-full h-3 w-3 bg-red-600" data-id="element-214"></span>
          </span>
          <p className="text-sm font-bold text-white tracking-wide" data-id="element-215">
            OFERTA LIMITADA:{' '}
            <span className="text-green-500" data-id="element-216">
              Solo quedan 7 cupos con bonus
            </span>
          </p>
        </div>

        <div className="flex items-center gap-2 bg-black/30 px-3 py-1 rounded-md border border-white/10" data-id="element-217">
          <Clock className="w-4 h-4 text-green-500" data-id="element-218" />
          <span className="text-sm font-mono font-bold text-white" data-id="element-219">
            00:{timeLeft.minutes.toString().padStart(2, '0')}:
            {timeLeft.seconds.toString().padStart(2, '0')}
          </span>
        </div>
      </div>
    </div>;
}